export const MENSAGEM_CIDADAO_FORA_AREA = 'Cidadão fora de área'
export const FORA_AREA = 'FA'
export const MSG_DADO_RECEBIDO_CADSUS = 'Dado recebido da base nacional. Não pode ser editado.'
const MSG_BASE_RESPONSAVEL = 'informado não pode pertencer ao próprio cidadão cadastrado.'
export const MSG_CPF_RESPONSAVEL_FAMILIAR_IGUAL_CIDADAO = 'CPF ' + MSG_BASE_RESPONSAVEL
export const MSG_CNS_RESPONSAVEL_FAMILIAR_IGUAL_CIDADAO = 'CNS ' + MSG_BASE_RESPONSAVEL
export const MSG_RESPONSAVEL_PRECISA_DE_CPF_OU_CNS = 'É obrigatório possuir CPF ou CNS para ser responsável familiar'
export const MSG_INFO_DOCUMENTOS_ASSOCIADOS =
  'É comum ter mais de um CNS devido a números provisórios acumulados, e isso não exige nenhuma ação. Se algum dos números pertencer a outra pessoa, gerencie em uma atualização de cadastro.'
export const MSG_SUBTITULO_GERENCIAMENTO_DOCUMENTOS =
  'Selecione as alterações que deseja fazer nos documentos associados. Elas serão aplicadas após salvar o cadastro. Na dúvida, mantenha os números e consulte sua coordenação.'
export const MSG_SALVAR_ALTERACOES_DOCUMENTOS_ASSOCIADOS =
  'Salve o cadastro para concluir as alterações dos documentos associados'
export const MSG_SEM_PERMISSAO_GERENCIAR_DOCUMENTOS =
  'Você não tem permissão para gerenciar documentos. Se necessário, contate a coordenação da unidade.'
export const CODIGO_PAIS_BRASIL = '31'
